import EmailDialog from './EmailDialog';

export default EmailDialog;
